export const KeepAliveTableMixins = {
    mounted() {
        this.$refs.dataTable.bodyWrapper.addEventListener(
            'scroll',
            (res) => {
                this.scrollTop = res.target.scrollTop;
                this.scrollLeft = res.target.scrollLeft;
            }
        );
    },
    activated () {
        this.$nextTick(() => {
            setTimeout(() => {
                this.$refs.dataTable.bodyWrapper.scrollTop = this.scrollTop;
                this.$refs.dataTable.bodyWrapper.scrollLeft = this.scrollLeft;
            }, 500);
        });
    },
}